import { getFullNameFromUnknown } from './_nameHelpers';
import { getTicketOpenerName } from './getTicketOpenerName';

import { TicketDetail, TicketMessage } from '@/services/TicketsService';

export function getTicketMessageAuthorName(
  message: TicketMessage,
  ticket: TicketDetail | undefined,
  userFallback: (id: number) => string,
  currentUser: {
    id: number;
    firstName: string;
    lastName: string;
  } | null,
) {
  const displayName = message.authorName?.trim();

  if (displayName) {
    return displayName;
  }

  const adminDisplayName =
    message.adminName?.trim() ||
    message.customerUserName?.trim() ||
    message.createdByName?.trim();

  if (adminDisplayName) {
    return adminDisplayName;
  }

  const firstName = message.authorFirstName?.trim() ?? '';
  const lastName = message.authorLastName?.trim() ?? '';
  const fullName = `${firstName} ${lastName}`.trim();

  if (fullName) {
    return fullName;
  }

  const supportName = message.supportName?.trim();

  if (supportName) {
    return supportName;
  }

  const messageAuthorFromObject =
    getFullNameFromUnknown(message.author) ||
    getFullNameFromUnknown(message.user);

  if (messageAuthorFromObject) {
    return messageAuthorFromObject;
  }

  if (
    ticket &&
    message.authorRole === 'admin' &&
    message.authorUserId === ticket.createdByUserId
  ) {
    const ticketOpenerName = getTicketOpenerName(ticket);

    if (ticketOpenerName) {
      return ticketOpenerName;
    }
  }

  if (currentUser && currentUser.id === message.authorUserId) {
    const currentUserName =
      `${currentUser.firstName} ${currentUser.lastName}`.trim();

    if (currentUserName) {
      return currentUserName;
    }
  }

  return userFallback(message.authorUserId);
}
